import { render, staticRenderFns } from "./sidebar-modulos.vue?vue&type=template&id=28f59c49&"
import script from "./sidebar-modulos.vue?vue&type=script&lang=js&"
export * from "./sidebar-modulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports